import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'SelectableCard',
  props: {
    label: {},
    selected: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function handleClick() {
  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-xl p-4 border text-center font-semibold transition-all duration-300 cursor-pointer select-none", [
        _ctx.selected && !_ctx.disabled
          ? 'border-green-400 bg-green-400/10 text-green-400'
          : _ctx.disabled
          ? 'border-red-400 bg-red-400/10 text-red-400 opacity-70'
          : 'border-[#333] bg-[#1A1A1A] text-white hover:border-[#C59C2F]',
      ]]),
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(_ctx.label), 1)
    ])
  ], 2))
}
}

})